import { Link, useNavigate, useParams } from "react-router-dom";
import PromptInputBox from "./PromptInputBox";
import SuggestedPrompts from "./SuggestedPrompts";
import Chat from "./Chat";
import { useEffect, useRef, useState } from "react";
import { promptedState, selectedPromptState } from "../../utils/recoil";
import { v4 as uuidv4 } from "uuid";
import { useRecoilState } from "recoil";
import config from "../../config";
import { Toast } from "primereact/toast";
import Cookies, { set } from "js-cookie";
import arrowIcon from "../../Assets/arrow-right.svg";
import { FaChevronLeft } from "react-icons/fa";
import Lottie from "react-lottie";
import animationData from "../../Assets/lottie/bot-animation-hello.json";

const ChatWindow = () => {
  const params = useParams();
  const tokenCookie = Cookies.get("token", { domain: config.cookieDomain });
  const isPaidCookie = Cookies.get("role", { domain: config.cookieDomain });
  const navigate = useNavigate();
  const newId = uuidv4();
  const toast = useRef(null);
  const [prompt, setPrompt] = useState("");
  const [answers, setAnswers] = useState([]);
  const [warning, setWarning] = useState(false);

  const [prompted, setPrompted] = useRecoilState(promptedState);
  const [selectedPrompt, setSelectedPrompt] =
    useRecoilState(selectedPromptState);

  const currentPrompt = localStorage.getItem("prompts");
  const chatHistory = localStorage.getItem("chatHistory");
  const userEmail = Cookies.get("email", { domain: config.cookieDomain });
  const [isLoading, setIsLoading] = useState(false);

  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  // const [sidebarOpen, setSidebarOpen] = useRecoilState(sidebarOpenState);

  useEffect(() => {
    if (!tokenCookie || !isPaidCookie) {
      setWarning(true);
    } else {
      setWarning(false);
    }
    let user = JSON.parse(localStorage.getItem("user"));
    if (user && userEmail in user) {
      let userData = user[userEmail];
      if (userData && "chat" in userData) {
        setAnswers(userData.chat);
        setWarning(false);
      }
    }
  }, [tokenCookie, isPaidCookie]);

  useEffect(() => {
    setPrompt(selectedPrompt);
  }, [selectedPrompt]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setPrompt("");
    try {
      await fetch(config.domain + "/chat", {
        credentials: "include",
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          data: {
            prompt: prompt,
          },
        }),
      })
        .then((res) => res.json())
        .then((res) => {
          if (res.statusCode === 200) {
            let chatObj = {
              prompt: prompt,
              answer: res.data,
            };
            let user = JSON.parse(localStorage.getItem("user"));
            if (user && userEmail in user) {
              let userData = user[userEmail];
              if (userData && "chat" in userData) {
                let previousChat = userData["chat"];
                let updatedChatHistory = [...previousChat, chatObj];
                const userDetails = {
                  [userEmail]: {
                    ...user[userEmail],
                    chat: updatedChatHistory,
                  },
                };
                localStorage.setItem("user", JSON.stringify(userDetails));
              } else {
                const userDetails = {
                  [userEmail]: {
                    ...user[userEmail],
                    chat: [chatObj],
                  },
                };
                localStorage.setItem("user", JSON.stringify(userDetails));
              }
            } else {
              const userDetails = {
                [userEmail]: {
                  chat: [chatObj],
                },
              };
              localStorage.setItem("user", JSON.stringify(userDetails));
            }

            setAnswers([...answers, chatObj]);
            setPrompt("");
            setPrompted(true);
            // if (!params.id) {
            //   // update chat history
            //   localStorage.setItem('chatHistory', prompt + ";next;" + (chatHistory ? chatHistory : ""));
            //   navigate(`/ai-agent/${newId || 1}`);
            // }
          } else {
            toast.current.show({
              severity: "warn",
              summary: "Warning",
              detail: "Something went wrong, Please try again later",
              life: 3000,
            });
          }
        });
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div
      className={`bg-[#EEF4FF] relative h-full w-full rounded-tl-2xl border-t border-l border-[#c8deff] overflow-hidden flex flex-col ${
        !params.id
          ? "justify-center items-center"
          : "justify-between px-20 py-10"
      }`}
    >
      {!tokenCookie || !(isPaidCookie === "ROLE_PAID_USER") ? (
        <div className="flex justify-center items-center">
          {!tokenCookie ? (
            <div className="flex items-center justify-center">
              <span>Sign In to continue</span>
              <Link to="/login">
                <button className="bg-[#3573F9] w-max rounded-full  text-white py-2 px-6 mx-3 flex items-center gap-3">
                  <p>Sign In</p>
                  <img src={arrowIcon} alt="Arrow" width={17} />
                </button>
              </Link>
            </div>
          ) : (
            !(isPaidCookie === "ROLE_PAID_USER") && (
              <div className="flex items-center justify-center">
                <span>Please take the Test</span>
                <Link to="/home">
                  <button className="bg-[#3573F9] w-max rounded-full text-white py-2 px-6 mx-3 flex items-center gap-3">
                    <p>Take the Test</p>
                    <img src={arrowIcon} alt="Arrow" width={17} />
                  </button>
                </Link>
              </div>
            )
          )}
        </div>
      ) : (
      <div>
        <Toast ref={toast} />
        {answers.length ? (
          <Chat id={params.id} answers={answers} isLoading={isLoading} />
        ) : (
          <SuggestedPrompts setPrompt={setPrompt} handleSubmit={handleSubmit} />
        )}
        <PromptInputBox
          setAnswers={setAnswers}
          id={params.id}
          prompt={prompt}
          setPrompt={setPrompt}
          handleSubmit={handleSubmit}
          isLoading={isLoading}
        />
        {/* <div 
        className="flex justify-between w-full max-w-5xl items-center mx-auto md-max:max-w-[90%]"
        > */}
        <div onClick={() => navigate(-1)} className="absolute top-5 left-5 flex items-center gap-3 cursor-pointer">
          <FaChevronLeft />
          GO BACK
        </div>
        {/* <Lottie options={defaultOptions} height={150} width={150} /> */}
        {/* </div> */}
      </div>
      )}
    </div>
  );
};

export default ChatWindow;
